import { render, staticRenderFns } from "./StaffManageSettingsView.vue?vue&type=template&id=f82a95a4&scoped=true"
import script from "./StaffManageSettingsView.vue?vue&type=script&lang=js"
export * from "./StaffManageSettingsView.vue?vue&type=script&lang=js"
import style0 from "./StaffManageSettingsView.vue?vue&type=style&index=0&id=f82a95a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82a95a4",
  null
  
)

export default component.exports